type TrackingApi = {
    pageView: (payload?: Record<string, any>) => void;
    trackEvent: (name: string, payload?: Record<string, any>) => void;
    trackClick: (payload?: Record<string, any>) => void;
    trackFormSubmit: (payload?: Record<string, any>) => void;
};

type AppTrackingConsent = "TRACK" | "DO_NOT_TRACK" | null;
type AppSiteContext = "app-ios" | "app-android" | "browser-desktop" | "browser-mobile" | null;
type AppPlatform = "ios" | "android" | null;

declare global {
    // eslint-disable-next-line no-var
    var dataLayer: any[] | undefined;
    // eslint-disable-next-line no-var
    var GewissTracking: TrackingApi | undefined;
    // eslint-disable-next-line no-var
    var __APP_TRACKING_CONSENT__: AppTrackingConsent | undefined;
    // eslint-disable-next-line no-var
    var __SITE_CONTEXT__: AppSiteContext | undefined;
    // eslint-disable-next-line no-var
    var __APP_PLATFORM__: AppPlatform | undefined;
    // eslint-disable-next-line no-var
    var __GTM_ENABLED__: boolean | undefined;
}

function dlPush(obj: Record<string, any>) {
    globalThis.dataLayer = globalThis.dataLayer || [];
    globalThis.dataLayer.push(obj);
}

export function initGtmTracking() {
    if (globalThis.GewissTracking) return;

    globalThis.GewissTracking = {
        pageView: (payload = {}) => dlPush({event: "virtual_pageview", ...payload}),
        trackEvent: (name, payload = {}) => dlPush({event: name, ...payload}),
        trackClick: (payload = {}) => dlPush({event: "cta_click", ...payload}),
        trackFormSubmit: (payload = {}) => dlPush({event: "form_submit", ...payload}),
    };

    console.log("[tracking] ready", globalThis.GewissTracking);
}

export function trackEvent(name: string, payload: Record<string, any> = {}) {
    globalThis.GewissTracking?.trackEvent(name, payload);
}

export function trackClick(payload: Record<string, any> = {}) {
    globalThis.GewissTracking?.trackClick(payload);
}

export function trackFormSubmit(payload: Record<string, any> = {}) {
    globalThis.GewissTracking?.trackFormSubmit(payload);
}